(function () {
  'use strict';

  var A = window.DevidAssistantCommerceV5;
  if (!A || window.DevidAssistantCommerceV7Ready) return;
  window.DevidAssistantCommerceV7Ready = true;

  var originalDepartment = A.department;

  function productIdentity(product) {
    return A.n([
      product && product.title,
      product && product.model,
      product && product.product_type,
      Array.isArray(product && product.tags) ? product.tags.join(' ') : '',
      A.collections(product)
    ].join(' '));
  }

  function productText(product) {
    return A.n([
      productIdentity(product),
      product && product.fit,
      product && product.description
    ].join(' '));
  }

  function detectFit(text) {
    var value = A.n(text);
    if (/\b(comod[oaie]?|comfort|relax|rilassat[oa]|oversize|ampio|morbido|loose)\b/.test(value)) return 'comfortable';
    if (/\b(regolare|regular|normale|classic[oa]?|classica|classico)\b/.test(value)) return 'regular';
    if (/\b(aderente|slim|skinny|fitted|sagomat[oa])\b/.test(value)) return 'slim';
    return '';
  }

  function detectWeight(text) {
    var value = A.n(text);
    if (/\b(invernal[ea]?|pesant[ea]?|cald[oaie]?|lana|cashmere|mohair|alpaca|felpat[oa]|imbottit[oa]|piumino|winter|wool)\b/.test(value)) return 'warm';
    if (/\b(legger[oaie]?|estiv[oaie]?|estate|primaverile|cotone|lino|linen|extra fine|ultralight|finezza 12|finezza 14|maglia aperta|tela vela|traspirante|summer|lightweight)\b/.test(value)) return 'light';
    return '';
  }

  function detectColor(text) {
    var value = A.n(text);
    if (/\b(total white|tutto bianco|monocromatico bianco)\b/.test(value)) return 'white';
    if (/\b(bianc[oa]|white|panna|avorio|cream|latte)\b/.test(value)) return 'white';
    if (/\b(nero|nera|black|antracite)\b/.test(value)) return 'black';
    if (/\b(blu navy|navy|blu notte|blu|blue|azzurro|acqua marina|acquamarina)\b/.test(value)) return 'blue';
    if (/\b(beige|sabbia|tortora|cammello|ecru)\b/.test(value)) return 'beige';
    if (/\b(verde|green|militare|oliva|ottanio)\b/.test(value)) return 'green';
    if (/\b(rosa|pink|fucsia|begonia)\b/.test(value)) return 'pink';
    if (/\b(rosso|red|bordeaux|burgundy)\b/.test(value)) return 'red';
    if (/\b(grigio|grey|gray)\b/.test(value)) return 'grey';
    if (/\b(moro|marrone|brown|cioccolato)\b/.test(value)) return 'brown';
    if (/\b(viola|purple|lilla)\b/.test(value)) return 'purple';
    if (/\b(animalier|leopard|fantasia|multicolor|stampa|print|floreale|righe|patch)\b/.test(value)) return 'pattern';
    return '';
  }

  function requestSubtype(text) {
    var value = A.n(text);
    var hasTshirt = /\b(t shirt|tshirt|t-shirt|tee)\b/.test(value);
    var hasPolo = /\bpolo\b/.test(value);
    var hasSweatshirt = /\b(felpa|felpe|hoodie|sweatshirt|fleece|felperia)\b/.test(value);
    var hasKnit = /\b(maglieria|maglione|maglioni|girocollo|pullover|cardigan|sweater|knitwear)\b/.test(value);
    var hasGenericMaglia = /\b(maglia|maglie)\b/.test(value);

    if (hasTshirt && hasPolo) return { subtype: 'light_tops', strict: false };
    if (hasSweatshirt && (hasKnit || hasGenericMaglia)) return { subtype: 'casual_tops', strict: false };
    if (hasSweatshirt) return { subtype: 'sweatshirt', strict: true };
    if (hasTshirt) return { subtype: 'tshirt', strict: true };
    if (hasPolo) return { subtype: 'polo', strict: true };
    if (/\b(camicia|camicie|button down|shirt)\b/.test(value)) return { subtype: 'shirt', strict: true };
    if (hasKnit) return { subtype: 'knitwear', strict: true };
    if (hasGenericMaglia) return { subtype: 'generic_top', strict: false };
    if (/\b(giacca|giacche|jacket|blazer|piumino|cappotto|parka|trench|k-way|kway)\b/.test(value)) return { subtype: 'jacket', strict: true };
    if (/\bcargo\b/.test(value)) return { subtype: 'cargo', strict: true };
    if (/\b(jeans|denim)\b/.test(value)) return { subtype: 'jeans', strict: true };
    if (/\bchino\b/.test(value)) return { subtype: 'chino', strict: true };
    if (/\bcarpenter\b/.test(value)) return { subtype: 'carpenter', strict: true };
    if (/\bjogger\b/.test(value)) return { subtype: 'jogger', strict: true };
    return { subtype: '', strict: false };
  }

  function categoryFromSubtype(subtype, text) {
    if (['sweatshirt', 'tshirt', 'polo', 'shirt', 'knitwear', 'generic_top', 'light_tops', 'casual_tops'].indexOf(subtype) >= 0) return 'tops';
    if (subtype === 'jacket') return 'outerwear';
    if (['cargo', 'jeans', 'chino', 'carpenter', 'jogger'].indexOf(subtype) >= 0) return 'pants';
    return A.category(text);
  }

  function productFamily(product) {
    var identity = productIdentity(product);
    if (/\b(felpa|felpe|hoodie|sweatshirt|fleece|felperia)\b/.test(identity)) return 'sweatshirt';
    if (/\b(t shirt|tshirt|t-shirt|tee)\b/.test(identity)) return 'tshirt';
    if (/\bpolo\b/.test(identity)) return 'polo';
    if (/\b(camicia|camicie|button down)\b/.test(identity)) return 'shirt';
    if (/\b(cardigan|maglieria|maglione|maglioni|girocollo|pullover|sweater|knitwear|maglia)\b/.test(identity)) return 'knitwear';
    if (/\b(giacca|giacche|jacket|blazer|piumino|cappotto|parka|trench|k-way|kway|outerwear)\b/.test(identity)) return 'jacket';
    if (/\bcargo\b/.test(identity)) return 'cargo';
    if (/\b(jeans|denim)\b/.test(identity)) return 'jeans';
    if (/\bchino\b/.test(identity)) return 'chino';
    if (/\bcarpenter\b/.test(identity)) return 'carpenter';
    if (/\bjogger\b/.test(identity)) return 'jogger';
    if (/\b(pantalon[ei]?|trousers)\b/.test(identity)) return 'pants';
    return '';
  }

  function familyCategory(family, product) {
    if (['sweatshirt', 'tshirt', 'polo', 'shirt', 'knitwear'].indexOf(family) >= 0) return 'tops';
    if (family === 'jacket') return 'outerwear';
    if (['cargo', 'jeans', 'chino', 'carpenter', 'jogger', 'pants'].indexOf(family) >= 0) return 'pants';
    return A.detectedCategory(product);
  }

  function productWeight(product) {
    var text = productText(product);
    var family = productFamily(product);
    var detected = detectWeight(text);
    if (detected) return detected;
    if (family === 'tshirt' || family === 'polo' || family === 'shirt') return 'light';
    if (family === 'sweatshirt') return 'warm';
    return '';
  }

  function allowedFamilies(intent) {
    if (!intent.subtype) return [];
    if (intent.strict) return [intent.subtype];
    if (intent.subtype === 'generic_top') return ['knitwear', 'polo', 'tshirt'];
    if (intent.subtype === 'light_tops') return ['tshirt', 'polo', 'knitwear'];
    if (intent.subtype === 'casual_tops') return ['sweatshirt', 'knitwear'];
    return [];
  }

  function isPoloInMaglia(product) {
    return productFamily(product) === 'polo' && /\b(in maglia|maglia aperta|knitted polo|polo in maglia)\b/.test(productText(product));
  }

  function matchTier(product, intent) {
    if (!product || !A.variantsOK(product)) return 99;
    if (intent.gender && !A.genderOK(product, intent.gender)) return 99;

    var family = productFamily(product);
    var category = familyCategory(family, product);
    if (intent.category && category !== intent.category) return 99;

    var weight = productWeight(product);
    var color = detectColor(productIdentity(product));
    var tier = 0;

    if (intent.strict && intent.subtype) {
      if (family !== intent.subtype) return 99;
      if (intent.weight === 'light' && weight === 'warm') return 99;
      if (intent.weight === 'warm' && weight === 'light') tier += 2;
      if (intent.weight && weight !== intent.weight) tier += 1;
    } else if (intent.subtype === 'generic_top') {
      if (allowedFamilies(intent).indexOf(family) < 0) return 99;
      if (intent.weight === 'light') {
        if (weight === 'warm') return 99;
        if ((family === 'knitwear' && weight === 'light') || isPoloInMaglia(product)) tier = 0;
        else if ((family === 'polo' || family === 'tshirt') && weight === 'light') tier = 1;
        else tier = 2;
      } else {
        tier = family === 'knitwear' || family === 'tshirt' || family === 'polo' ? 0 : 1;
      }
    } else if (intent.subtype === 'light_tops') {
      if (allowedFamilies(intent).indexOf(family) < 0 || weight === 'warm') return 99;
      tier = family === 'tshirt' || family === 'polo' ? 0 : 1;
    } else if (intent.subtype === 'casual_tops') {
      if (allowedFamilies(intent).indexOf(family) < 0) return 99;
      tier = 0;
    }

    if (intent.color) {
      if (color === intent.color) tier -= 1;
      else if (color) tier += 2;
      else tier += 1;
    }

    return Math.max(0, tier);
  }

  function heroBoost(product, intent) {
    var identity = productIdentity(product);
    var score = 0;
    if (intent.gender === 'men' && intent.category === 'tops' && intent.weight === 'light') {
      if (/\bcorniglia\b/.test(identity)) score += 120;
      if (/\balassio\b/.test(identity)) score += 110;
      if (/\b(monterosso|vernazza|malpasso)\b/.test(identity)) score += 80;
      if (/\b(mosca|shiro|siviglia)\b/.test(identity)) score += 45;
    }
    if (intent.gender === 'women' && intent.category === 'tops' && intent.weight === 'light') {
      if (/\b(mc2 saint barth|saint barth)\b/.test(A.n(product.vendor))) score += 28;
      if (/\b(polo|t shirt|tshirt|t-shirt|top)\b/.test(identity)) score += 18;
    }
    return score;
  }

  function semanticScore(product, intent) {
    var tier = matchTier(product, intent);
    if (tier >= 99) return -10000;
    var score = A.score(product, intent.raw, intent.gender, intent.category, intent.fit);
    var identity = productIdentity(product);
    var family = productFamily(product);
    var weight = productWeight(product);

    score += heroBoost(product, intent);
    score += Math.max(0, 70 - tier * 28);
    if (intent.weight === 'light' && weight === 'light') score += 32;
    if (intent.weight === 'warm' && weight === 'warm') score += 24;
    if (intent.fit === 'comfortable') {
      if (/\b(portorico|cargo|jogger|comfort|comodo|relax|regular|morbido|stretch|elastico|ampio|loose)\b/.test(productText(product))) score += 28;
      if (/\b(skinny|super slim|aderente)\b/.test(productText(product))) score -= 32;
    }
    if (intent.fit === 'regular' && /\b(regular|regolare|classic|classico|normale)\b/.test(productText(product))) score += 18;
    if (intent.fit === 'slim' && /\b(slim|skinny|aderente|fitted|sagomato)\b/.test(productText(product))) score += 18;
    if (intent.color && detectColor(identity) === intent.color) score += 30;
    if (intent.brand) {
      var vendor = A.n(product.vendor);
      if (vendor.indexOf(intent.brand) >= 0 || intent.brand.indexOf(vendor) >= 0) score += 55;
    }
    if (A.n(product.vendor) === 'devid label') score += 20;
    if (intent.subtype === 'generic_top' && family === 'knitwear') score += 10;
    return score;
  }

  function rankedProducts(products, intent) {
    return A.unique(products.filter(function (product) {
      return matchTier(product, intent) < 99;
    }).sort(function (first, second) {
      var tierDifference = matchTier(first, intent) - matchTier(second, intent);
      if (tierDifference) return tierDifference;
      return semanticScore(second, intent) - semanticScore(first, intent);
    }));
  }

  function flexiblePool(products, intent) {
    var ranked = rankedProducts(products, intent);
    if (!ranked.length) return ranked;
    var minimum = matchTier(ranked[0], intent);
    var ceiling = intent.strict ? minimum : minimum + 1;
    var pool = ranked.filter(function (product) { return matchTier(product, intent) <= ceiling; });
    if (pool.length < 5 && !intent.strict) {
      ranked.forEach(function (product) {
        if (pool.length < 10 && pool.indexOf(product) < 0 && matchTier(product, intent) <= minimum + 2) pool.push(product);
      });
    }
    return pool;
  }

  function genderLabel(gender) {
    if (gender === 'women') return A.en ? 'women' : 'donna';
    return A.en ? 'men' : 'uomo';
  }

  function addQuery(queries, value) {
    var normalized = A.n(value);
    if (!normalized) return;
    for (var index = 0; index < queries.length; index += 1) {
      if (A.n(queries[index]) === normalized) return;
    }
    queries.push(value);
  }

  A.department = function (product) {
    if (/\bportorico\b/.test(productIdentity(product))) return 'women';
    return originalDepartment(product);
  };

  A.intent = function (text, seed) {
    var previous = seed || {};
    var raw = [previous.raw || '', text || ''].join(' ').replace(/\s+/g, ' ').trim();
    var type = requestSubtype(raw);
    var subtype = type.subtype || previous.subtype || '';
    var category = categoryFromSubtype(subtype, raw) || previous.category || '';
    var color = detectColor(raw) || previous.color || '';
    return {
      raw: raw,
      category: category,
      subtype: subtype,
      strict: type.subtype ? type.strict : Boolean(previous.strict),
      gender: A.gender(raw) || previous.gender || '',
      fit: detectFit(raw) || previous.fit || '',
      weight: detectWeight(raw) || previous.weight || '',
      color: color,
      brand: A.vendorRequested(raw) || previous.brand || '',
      totalWhite: /\b(total white|tutto bianco|monocromatico bianco)\b/.test(A.n(raw))
    };
  };

  A.productIdentityV7 = productIdentity;
  A.productSubtype = productFamily;
  A.productFamilyV7 = productFamily;
  A.productWeight = productWeight;
  A.productColorV7 = function (product) { return detectColor(productIdentity(product)); };
  A.matchTierV7 = matchTier;
  A.semanticOK = function (product, intent) { return matchTier(product, intent) < 99; };
  A.semanticScore = semanticScore;

  A.queries = function (category, gender, request) {
    var intent = A.intent(request || '', { category: category, gender: gender });
    var label = genderLabel(gender);
    var queries = [];
    addQuery(queries, intent.raw);

    if (intent.subtype === 'generic_top' && intent.weight === 'light' && gender === 'men') {
      ['Corniglia', 'Alassio', 'maglia cotone finezza 14 uomo', 'maglia leggera uomo', 'polo in maglia uomo', 't-shirt cotone uomo', 'MC2 Saint Barth polo uomo', 'Replay t-shirt uomo'].forEach(function (query) { addQuery(queries, query); });
    } else if (intent.subtype === 'generic_top' && intent.weight === 'light' && gender === 'women') {
      ['maglia leggera donna', 'polo donna cotone', 't-shirt donna', 'top donna', 'MC2 Saint Barth polo donna', 'MC2 Saint Barth t-shirt donna', 'Manila Grace top donna', 'Replay t-shirt donna', 'Devid Label t-shirt donna'].forEach(function (query) { addQuery(queries, query); });
    } else if (intent.subtype === 'generic_top') {
      ['maglia ' + label, 't-shirt ' + label, 'polo ' + label, 'maglieria ' + label].forEach(function (query) { addQuery(queries, query); });
    } else if (intent.subtype === 'sweatshirt') {
      ['felpa ' + label, 'hoodie ' + label, 'felperia ' + label].forEach(function (query) { addQuery(queries, query); });
    } else if (intent.subtype === 'knitwear') {
      ['maglieria ' + label, 'maglia ' + label, 'girocollo ' + label].forEach(function (query) { addQuery(queries, query); });
    } else if (intent.subtype === 'tshirt') {
      ['t-shirt ' + label, 'tee ' + label, 'Devid Label t-shirt ' + label, 'MC2 Saint Barth t-shirt ' + label, 'Replay t-shirt ' + label].forEach(function (query) { addQuery(queries, query); });
    } else if (intent.subtype === 'polo') {
      ['polo ' + label, 'polo in maglia ' + label, 'Devid Label polo ' + label, 'MC2 Saint Barth polo ' + label].forEach(function (query) { addQuery(queries, query); });
    } else if (intent.subtype === 'shirt') {
      addQuery(queries, 'camicia ' + label);
    } else if (intent.subtype === 'jacket') {
      ['giacca ' + label, 'outerwear ' + label, 'K-Way ' + label].forEach(function (query) { addQuery(queries, query); });
    } else if (intent.subtype === 'cargo') {
      ['cargo ' + label, 'pantalone cargo ' + label].forEach(function (query) { addQuery(queries, query); });
    } else if (intent.subtype === 'jeans') {
      ['jeans ' + label, 'denim ' + label].forEach(function (query) { addQuery(queries, query); });
    } else if (category === 'pants') {
      ['pantalone ' + label, 'cargo ' + label, 'jeans ' + label].forEach(function (query) { addQuery(queries, query); });
    } else if (category === 'tops') {
      ['t-shirt ' + label, 'polo ' + label, 'maglia ' + label, 'felpa ' + label].forEach(function (query) { addQuery(queries, query); });
    } else if (category === 'outerwear') {
      ['giacca ' + label, 'K-Way ' + label].forEach(function (query) { addQuery(queries, query); });
    } else if (category === 'summer') {
      ['mare ' + label, 'costume ' + label, 'bermuda ' + label].forEach(function (query) { addQuery(queries, query); });
    } else {
      ['accessori ' + label, 'borsa ' + label, 'zaino ' + label].forEach(function (query) { addQuery(queries, query); });
    }

    if (intent.color) addQuery(queries, (intent.subtype === 'tshirt' ? 't-shirt ' : '') + intent.color + ' ' + label);
    if (intent.fit === 'comfortable' && category === 'pants') {
      ['pantalone comodo ' + label, 'pantalone cargo ' + label, 'pantalone relax ' + label].forEach(function (query) { addQuery(queries, query); });
    }
    if (intent.brand) addQuery(queries, intent.brand + ' ' + label);
    return queries.slice(0, 11);
  };

  A.selectMixedProducts = function (products, request, gender, category, fit) {
    var intent = A.intent(request || '', { gender: gender, category: category, fit: detectFit(fit) || fit || '' });
    var valid = flexiblePool(products, intent);
    if (!valid.length) return [];

    if (intent.brand) {
      var brandMatches = valid.filter(function (product) {
        var vendor = A.n(product.vendor);
        return vendor.indexOf(intent.brand) >= 0 || intent.brand.indexOf(vendor) >= 0;
      });
      if (brandMatches.length) return brandMatches.slice(0, 5);
    }

    var devid = valid.filter(function (product) { return A.n(product.vendor) === 'devid label'; });
    var external = valid.filter(function (product) { return A.n(product.vendor) !== 'devid label'; });
    var selected = devid.slice(0, 2);
    var vendors = {};

    external.forEach(function (product) {
      var vendor = A.n(product.vendor);
      if (selected.length < 5 && vendor && !vendors[vendor]) {
        vendors[vendor] = true;
        selected.push(product);
      }
    });
    valid.forEach(function (product) {
      if (selected.length < 5 && selected.indexOf(product) < 0) selected.push(product);
    });
    return selected.slice(0, 5);
  };

  A.partnerCategory = function (base) {
    var category = familyCategory(productFamily(base), base);
    if (category === 'pants') return 'tops';
    if (category === 'tops') return 'pants';
    if (category === 'outerwear') return 'tops';
    if (category === 'summer') return 'tops';
    return 'accessories';
  };

  function colorCompatibility(base, partner, intent) {
    var baseColor = A.productColorV7(base);
    var partnerColor = A.productColorV7(partner);
    var baseIdentity = productIdentity(base);
    var partnerIdentity = productIdentity(partner);
    var score = 0;

    if (baseColor === 'white' && partnerColor === 'white' && !intent.totalWhite) return -200;
    if (baseColor && partnerColor && baseColor === partnerColor) {
      if (baseColor === 'black' || baseColor === 'blue') score += 3;
      else score -= 24;
    }
    if (baseColor === 'white' && ['black', 'blue', 'beige', 'green', 'red', 'pink', 'pattern'].indexOf(partnerColor) >= 0) score += 28;
    if (partnerColor === 'white' && ['black', 'blue', 'beige', 'green', 'red', 'pink', 'pattern'].indexOf(baseColor) >= 0) score += 18;
    if (baseColor === 'pattern' && ['white', 'black', 'blue', 'beige', 'grey'].indexOf(partnerColor) >= 0) score += 22;
    if (partnerColor === 'pattern' && ['white', 'black', 'blue', 'beige', 'grey'].indexOf(baseColor) >= 0) score += 22;
    if (/\bjeans|denim\b/.test(baseIdentity + ' ' + partnerIdentity) && (baseColor === 'white' || partnerColor === 'white')) score += 18;
    if (!baseColor || !partnerColor) score += 2;
    return score;
  }

  A.dynamicPartnerQueries = function (base, intent) {
    var label = genderLabel(intent.gender);
    var target = A.partnerCategory(base);
    var baseColor = A.productColorV7(base);
    var queries = [];

    if (target === 'tops') {
      if (baseColor === 'white') {
        ['t-shirt nera ' + label, 't-shirt colorata ' + label, 'polo ' + label, 'MC2 Saint Barth t-shirt ' + label].forEach(function (query) { addQuery(queries, query); });
      } else {
        ['t-shirt ' + label, 'polo ' + label, 'top ' + label, 'MC2 Saint Barth t-shirt ' + label, 'Devid Label t-shirt ' + label].forEach(function (query) { addQuery(queries, query); });
      }
    } else if (target === 'pants') {
      if (baseColor === 'white') {
        ['pantalone nero ' + label, 'pantalone sabbia ' + label, 'jeans ' + label, 'cargo verde ' + label, 'Replay pantalone ' + label, 'Devid Label pantalone ' + label].forEach(function (query) { addQuery(queries, query); });
      } else {
        ['pantalone ' + label, 'cargo ' + label, 'jeans ' + label, 'Devid Label pantalone ' + label, 'Replay pantalone ' + label].forEach(function (query) { addQuery(queries, query); });
      }
    } else {
      addQuery(queries, 'accessori ' + label);
    }
    return queries.slice(0, 7);
  };

  A.partnerOKV6 = function (base, partner, intent) {
    if (!partner || partner.id === base.id || !A.variantsOK(partner)) return false;
    if (!A.genderOK(partner, intent.gender)) return false;
    if (familyCategory(productFamily(partner), partner) !== A.partnerCategory(base)) return false;
    if (colorCompatibility(base, partner, intent) <= -150) return false;
    return true;
  };

  A.partnerScoreV6 = function (base, partner, intent) {
    var score = A.score(partner, '', intent.gender, A.partnerCategory(base), '');
    var baseVendor = A.n(base.vendor);
    var partnerVendor = A.n(partner.vendor);
    var partnerText = productText(partner);
    score += colorCompatibility(base, partner, intent);
    if (baseVendor !== partnerVendor) score += 18;
    if (baseVendor === 'devid label' && /mc2 saint barth|saint barth/.test(partnerVendor) && A.partnerCategory(base) === 'tops') score += 20;
    if (baseVendor !== 'devid label' && partnerVendor === 'devid label') score += 15;
    if (intent.weight === 'light' && /\b(lana|cashmere|velluto|invernale|pesante)\b/.test(partnerText)) score -= 24;
    if (/\b(regular|regolare|comfort|comodo|stretch)\b/.test(partnerText)) score += 5;
    return score;
  };

  A.selectDynamicPartnerV6 = function (base, products, intent) {
    return products.filter(function (product) {
      return A.partnerOKV6(base, product, intent);
    }).sort(function (first, second) {
      return A.partnerScoreV6(base, second, intent) - A.partnerScoreV6(base, first, intent);
    })[0] || null;
  };

  A.fetchPartnerPoolV6 = async function (bases, intent) {
    var list = Array.isArray(bases) ? bases : [bases];
    var queries = [];
    list.slice(0, 4).forEach(function (base) {
      A.dynamicPartnerQueries(base, intent).forEach(function (query) { addQuery(queries, query); });
    });
    var results = await Promise.all(queries.slice(0, 12).map(function (query) {
      return A.feed(query).catch(function () { return []; });
    }));
    var seen = {};
    return results.flat().filter(function (product) {
      var key = product && (product.id || product.handle);
      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  };

  A.resolvePartnerV6 = async function (base, intent, pool) {
    if (A.partnerOKV6(base, base.bundle_partner, intent)) return base.bundle_partner;
    var candidates = pool || await A.fetchPartnerPoolV6(base, intent);
    return A.selectDynamicPartnerV6(base, candidates, intent);
  };

  A.attachDynamicPartnersV6 = async function (products, intent) {
    if (!products.length) return products;
    var pool = await A.fetchPartnerPoolV6(products, intent);
    return Promise.all(products.map(async function (product) {
      var partner = await A.resolvePartnerV6(product, intent, pool);
      if (partner) product.bundle_partner = partner;
      return product;
    }));
  };

  A.findLookPairV6 = async function (products, intent) {
    var bases = flexiblePool(products, intent).slice(0, 6);
    if (!bases.length) return null;
    var pool = await A.fetchPartnerPoolV6(bases, intent);
    var best = null;
    var bestScore = -Infinity;

    for (var index = 0; index < bases.length; index += 1) {
      var base = bases[index];
      var configured = A.partnerOKV6(base, base.bundle_partner, intent);
      var partner = configured ? base.bundle_partner : A.selectDynamicPartnerV6(base, pool, intent);
      if (!partner) continue;
      var pairScore = semanticScore(base, intent) - matchTier(base, intent) * 45 + A.partnerScoreV6(base, partner, intent);
      if (pairScore > bestScore) {
        bestScore = pairScore;
        base.bundle_partner = partner;
        base.assistant_pair_source = configured ? 'configured_bundle' : 'dynamic_catalog';
        best = base;
      }
    }
    return best;
  };
})();